import { ModuleWithProviders, NgModule } from '@angular/core';
import { UserService } from './user.service';

@NgModule()
export class UserServiceModule {
  static forRoot(): ModuleWithProviders<UserServiceModule> {
    return {
      ngModule: UserServiceModule,
      providers: [UserService]
    };
  }
}
